import React from 'react';
import Header from "../Components/Header";
import MainContent from '../scenes/About/MainContent';
import Footer from "../Components/Footer";
import './about.css';
import Banner from '../Components/Banner';
import backgroundImage from "../assets/indian_trucker2.jpeg";

const AboutLayout = () => {
  return (
    <div className="bg-topo-bg">
      <Header />
      
      <Banner 
      imageUrl={backgroundImage}
      title="About"
      subtitle="Learn more about our company and our mission" />
      <MainContent />
      
      <Footer />
    </div>
  );
};

export default AboutLayout;